import styled from "styled-components";
import Icon from "../../icon";

export const Container = styled.div`
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  margin: 0px auto;
  max-width: 277px;

  @media (min-width: 414px) {
    max-width: 371px;
  }
  @media (min-width: 768px) {
    max-width: 725px;
  }
`;

export const SocialList = styled.ul`
  align-items: center;
  display: flex;
  justify-content: space-between;
  list-style: none;
  padding: 0 0 24px 0;
  border-bottom: 0.5px solid #dae8f7;
`;
export const HelperLinks = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 14px 0 0;
`;

export const SocialItem = styled.li``;

export const SocialLink = styled.a``;

export const SocialIcon = styled(Icon)`
  fill: ${(props) => props.color};

  @media (max-width: 1365px) {
    height: 25px;
    width: 40px;
  }

  @media (max-width: 1023px) {
    height: 32px;
    width: 45px;
  }

  @media (max-width: 767px) {
    height: 16px;
    width: 22px;
  }
`;

export const SocialImg = styled.img`
  @media (max-width: 1023px) {
    height: 26px;
    width: 32px;
  }

  @media (max-width: 767px) {
    height: 16px;
    width: 22px;
  }
`;

export const Links = styled.ul`
  font-family: "Nunito", sans-serif;
  list-style: none;
  margin: 0 0 24px 0;
  padding-left: 0;
`;

export const LinkItem = styled.li`
  :not(:last-child) {
    margin: 0 0 8px;
  }
`;

export const Link = styled.a`
  color: #ffffff;
  font-size: 1rem;
  font-weight: 400;

  &:hover,
  &:visited {
    color: #ffffff;
  }
`;

export const AppsBox = styled.div``;

export const AppsLink = styled.a`
  display: block;
  :not(:last-child) {
    margin: 0 0 8px;
  }
`;

export const AppsImage = styled.img``;
